import React from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { buttonVariants } from '@react/shared/ui/Button'
import { environmentOf, environmentLabel, hostOf } from '../helpers'

const EnvironmentCard = ({ environment }) => {
  const kind = environmentOf(environment)

  return (
    <div className="flex items-center gap-3 rounded-xl border-[1px] border-slate-200 bg-slate-50 px-[16px] py-[12px]">
      <span className={clsx('flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-[14px]', kind.tile)}>
        <FontAwesomeIcon icon={kind.icon} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-semibold leading-snug text-slate-900">{environmentLabel(environment)}</div>
        <div className="truncate text-[12px] leading-snug text-slate-500">
          {environment.url ? `${hostOf(environment.url)} · ${kind.hint}` : kind.hint}
        </div>
      </div>
      {environment.url && (
        <a
          href={environment.url}
          target="_blank"
          rel="noopener noreferrer"
          className={clsx(buttonVariants({ variant: 'primary', size: 'md' }), 'shrink-0 no-underline hover:text-white hover:no-underline focus:text-white')}
        >
          Ouvrir
          <FontAwesomeIcon icon="arrow-up-right-from-square" className="text-[11px]" />
        </a>
      )}
    </div>
  )
}

export default EnvironmentCard
